export default __webpack_public_path__ + "static/media/before@2x.07f6eaf9.png";